// extracted by mini-css-extract-plugin
module.exports = {"container":"otp-channel-selector-list_container__myBbv","contentWrapper":"otp-channel-selector-list_contentWrapper__vJYJK"};